/**
 * i18n messages for the "edit a signed certificate" choice dialog (en/ar).
 * Registered in core/plugins/i18n.ts under its own top-level `signatureDecision`
 * key: that merge is shallow, so the namespace must not be shared with another file.
 * CSP-safe compiler: only `{named}` placeholders.
 */
export const signatureDecisionMessages = {
  en: {
    signatureDecision: {
      title: "This certificate carries signatures",
      body: "Choose what happens to the signatures when this change is saved.",
      keepHint:
        "Update certificate keeps the signatures as they are on the changed certificate.",
      withdrawHint:
        "Send for signatures withdraws them and opens the send dialog, so the scholars sign the new version.",
      keep: "Update certificate",
      withdraw: "Send for signatures",
      cancel: "Cancel",
      notFoundAfterWithdraw:
        "The signatures were withdrawn, but the certificate could not be opened here. Send it for signatures from the list.",
    },
  },
  ar: {
    signatureDecision: {
      title: "تحمل هذه الشهادة توقيعات",
      body: "اختر ما يحدث للتوقيعات عند حفظ هذا التغيير.",
      keepHint: "تحديث الشهادة يُبقي التوقيعات كما هي على الشهادة المعدّلة.",
      withdrawHint:
        "الإرسال للتوقيعات يسحب التوقيعات ويفتح نافذة الإرسال ليوقّع العلماء النسخة الجديدة.",
      keep: "تحديث الشهادة",
      withdraw: "إرسال للتوقيعات",
      cancel: "إلغاء",
      notFoundAfterWithdraw:
        "تم سحب التوقيعات، لكن تعذّر فتح الشهادة هنا. أرسلها للتوقيعات من القائمة.",
    },
  },
};
